// extracted by mini-css-extract-plugin
export default {"nameCell":"global-meta-table-row_nameCell__G-Wtu"};